/* eslint-disable no-unused-vars */
export enum MoodEnum {
  VERY_BAD = 'VERY_BAD',
  BAD = 'BAD',
  NEUTRAL = 'NEUTRAL',
  GOOD = 'GOOD',
  VERY_GOOD = 'VERY_GOOD',
}
